<div class="navbar flex flex-space-between">
  <a routerLink="/audits">
    <img alt="Social auditor" class="logo" src="assets/images/social-auditor-logo.png" />
  </a>
  <ul class="navigation">
    <ng-template [ngIf]="!(isAuthenticated() | async)">
      <li class="navigation-item">
        <a routerLink="/signup" class="btn btn-light" title="Register">
          Register
        </a>
      </li>
      <li class="navigation-item">
        <a routerLink="/signin" class="btn btn-default" title="Login">
         Login
        </a>
      </li>
    </ng-template>
    <ng-template [ngIf]="isAuthenticated() | async">
      <li class="navigation-item dropdown-item">
        <a routerLink="/audit/add" class="btn btn-default" title="Check new profile">
         New report
        </a>
        <div class="submenu">
          <ul class="submenu-nav">
            <li class="submenu-item" data-ktmenu-submenu-toggle="hover" aria-haspopup="true">
              <a routerLink="/audit/add">
                <img class="submenu-icon" src="assets/images/icons/add.png"/>
                <span>Generate new profile report</span>
              </a>
            </li>
            <li class="submenu-item" data-ktmenu-submenu-toggle="hover" aria-haspopup="true">
              <a routerLink="/post/add">
                <img class="submenu-icon" src="assets/images/icons/add.png"/>
                <span>Generate new post report</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
      <li class="navigation-item dropdown-item">
        <a routerLink="/audits" class="btn btn-default" title="List of reports">
          List of reports
        </a>
        <div class="submenu">
          <ul class="submenu-nav">
            <li class="submenu-item" data-ktmenu-submenu-toggle="hover" aria-haspopup="true">
              <a routerLink="/audits">
                <img class="submenu-icon" src="assets/images/icons/list.png"/>
                <span>List of profile reports</span>
              </a>
            </li>
            <li class="submenu-item" data-ktmenu-submenu-toggle="hover" aria-haspopup="true">
              <a routerLink="/posts">
                <img class="submenu-icon" src="assets/images/icons/list.png"/>
                <span>List of posts reports</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
      <li class="navigation-item">
        <a routerLink="/compare/profile" class="btn btn-default" title="Compare profile audits">
          Compare profiles <small class="text-blue">NEW!</small>
        </a>
      </li>
      <li class="navigation-item">
        <a routerLink="/payment/add" class="btn btn-default" title="Buy more credits">
          <img width="14" class="mr-1" src="assets/images/icons/star.png"/>
          Buy credits
        </a>
      </li>
    </ng-template>
  </ul>
  <ng-template [ngIf]="isAuthenticated() | async">
    <ul class="navigation float-right">
      <li class="navigation-item" aria-haspopup="true" *ngIf="(isAuthenticated() | async) || ((userState | async).user !== null && (userState | async).user.type > -1)">
        <a routerLink="/settings/user" class="btn btn-default btn-circle">
          <img alt="Logout" class="logout" src="assets/images/icons/settings.png"/>
        </a>
      </li>
      <li class="navigation-item" aria-haspopup="true" *ngIf="(isAuthenticated() | async) || ((userState | async).user !== null && (userState | async).user.type > -1)">
        <a (click)="logout()" class="btn btn-default btn-circle">
          <img alt="Logout" class="logout" src="assets/images/icons/turnoff.png"/>
        </a>
      </li>
    </ul>
  </ng-template>
</div>


<header id="m_header" class="m-grid__item m-header" m-minimize="minimize" m-minimize-mobile="minimize" m-minimize-offset="200" m-minimize-mobile-offset="200" *ngIf="(isAuthenticated() | async)">
  <div class="m-container m-container--fluid m-container--full-height">
    <div class="m-stack m-stack--ver m-stack--desktop  m-header__wrapper">
      <div class="m-stack__item m-brand m-brand--mobile">
        <div class="m-stack m-stack--ver m-stack--general">
          <div class="m-stack__item m-stack__item--middle m-brand__logo">
            <a routerLink="/audits" class="m-brand__logo-wrapper">
              <img alt="Social auditor" class="logo" src="assets/images/social-auditor-logo.png"/>
            </a>
          </div>
          <div class="m-stack__item m-stack__item--middle m-brand__tools">
            <a (click)="toggleMenu($event)" id="m_aside_left_toggle_mobile" class="m-brand__icon m-brand__toggler m-brand__toggler--left">
              <span></span>
            </a>
          </div>
        </div>
      </div>
      <div id="m_aside_left" class="m-aside-left m-aside-left--skin-dark" [exclude]="'#m_aside_left_toggle_mobile'" (clickOutside)="closeMenuWhenOpen()" [ngClass]="mobileMenu ? 'm-aside-left--on' : 'm-aside-left--enabled'">
        <!-- BEGIN: Aside Menu -->
        <div id="m_ver_menu" class="m-aside-menu m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark m-scroller" data-menu-vertical="true" m-menu-scrollable="1" m-menu-dropdown-timeout="500" style="height: auto; overflow: hidden;">
          <ul class="m-menu__nav  m-menu__nav--dropdown-submenu-arrow" (click)="closeMenuWhenOpen()">
            <li class="m-menu__section">
              <h4 class="m-menu__section-text">Profile reports</h4>
            </li>
            <li class="m-menu__item" aria-haspopup="true">
              <a routerLink="/audit/add" class="m-menu__link m-menu__link__blue">
                Generate new report
              </a>
            </li>
            <li class="m-menu__item" aria-haspopup="true">
              <a routerLink="/audits" class="m-menu__link">
                List of profile reports
              </a>
            </li>
            <li class="m-menu__item" aria-haspopup="true">
              <a routerLink="/compare/profile" class="m-menu__link ">
                Compare profiles <span class="text-blue">NEW!</span>
              </a>
            </li>
            <li class="m-menu__section">
              <h4 class="m-menu__section-text">Posts reports</h4>
            </li>
            <li class="m-menu__item" aria-haspopup="true">
              <a routerLink="/post/add" class="m-menu__link">
                Generate new post report
              </a>
            </li>
            <li class="m-menu__item" aria-haspopup="true">
              <a routerLink="/posts" class="m-menu__link">
                List of post reports
              </a>
            </li>
            <li class="m-menu__section">
              <h4 class="m-menu__section-text">Credits</h4>
            </li>
            <li class="m-menu__item" aria-haspopup="true">
              <a routerLink="/payment/add" class="m-menu__link m-menu__link__orange">
                <img width="12" class="mr-1" src="assets/images/icons/star.png">
                Buy credits
              </a>
            </li>
            <hr>
            <li class="m-menu__item" aria-haspopup="true" *ngIf="(isAuthenticated() | async) || ((userState | async).user !== null && (userState | async).user.type > -1)">
              <a routerLink="/settings/user" class="m-menu__link m-menu__logout">
                Settings
              </a>
            </li>
            <li class="m-menu__item" aria-haspopup="true" *ngIf="(isAuthenticated() | async) || ((userState | async).user !== null && (userState | async).user.type > -1)">
              <a (click)="logout()" class="m-menu__link m-menu__logout">
                Logout
              </a>
            </li>

            <li class="m-menu__item" aria-haspopup="true" *ngIf="(userState | async).user !== null && (userState | async).user.type === -1">
              <a routerLink="/user/register" class="m-menu__link m-menu__register" title="Register">
                Register
              </a>
            </li>
          </ul>
        </div>

        <!-- END: Aside Menu -->

      </div>
    </div>
  </div>
</header>

<header class="m-grid__item m-header" m-minimize="minimize" m-minimize-mobile="minimize" m-minimize-offset="200" m-minimize-mobile-offset="200" *ngIf="!(isAuthenticated() | async) && !hideTopBar">
  <div class="m-container m-container--fluid m-container--full-height">
    <div class="m-stack m-stack--ver m-stack--desktop  m-header__wrapper">
      <div class="m-stack__item m-brand m-brand--mobile">
        <div class="m-stack m-stack--ver m-stack--general">
          <div class="m-stack__item m-stack__item--middle m-brand__logo">
            <a routerLink="/audits" class="m-brand__logo-wrapper">
              <img alt="Social auditor" height="30" src="assets/images/social-auditor-logo.png" />
            </a>
          </div>
        </div>
      </div>
      <div class="m-stack__item m--margin-top-25">
        <a routerLink="/audits" class="m-brand m-brand--desktop">
          <img alt="Social auditor" height="30" src="assets/images/social-auditor-logo.png" />
        </a>
      </div>
    </div>
  </div>
</header>
